export const headerCellStyle = {
    fontSize: 14, // Adjust the font size as needed
    fontWeight: "bold",
    backgroundColor: "#4CB5F5",
    color: "white",
    my: 0,
    py:1,
};

export const cellStyle = {
    py: 0,
    my: 0,
};

export const evenRowStyle = {
    background: "#f5f5f5",
};

export const oddRowStyle = {
    background: "white",
};

export const rowStyle = {
    "&:hover": {
        background: "#f1f9fe",
    },
};